import { OfferingType } from '../../graphql/__generated__';
import type { FilterValues } from '../calendar/model/calendar-filters';

export const DEFAULT_FILTERS: FilterValues = {
  offeringType: [
    OfferingType.Ipo,
    OfferingType.IpoSpac,
    OfferingType.FollowOn,
    OfferingType.MarketedFo,
    OfferingType.OvernightFo,
    OfferingType.Rights,
    OfferingType.RegisteredBlock,
    OfferingType.UnregisteredBlock,
    OfferingType.Convertible,
    OfferingType.RegisteredDirect,
    OfferingType.DirectListing,
    OfferingType.UnderwrittenRd,
  ],
  sector: [],
  customSectorId: [],
  sizeInDollars: {
    min: undefined,
    max: undefined,
  },
  marketCap: {
    min: undefined,
    max: undefined,
  },
  leftLeadFirmId: [],
  managerFirmId: [],
  useCustomSectors: false,
  countries: [],
  aiInterestSummary: '',
};

export const CALENDAR_NEXT_MIXPANEL_EVENT_NAME = 'Calendar Grid Next';
